/* Washington Diamond — client film modal
   Opens a YouTube iframe on demand (nothing is embedded until clicked, so the
   page carries no YouTube weight on load). Escape-to-close, focus trap, focus
   return, and body scroll lock. */
(function () {
  var FOCUSABLE =
    'a[href], button:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])';

  function init(root) {
    if (!root || root.dataset.wdFilmsReady === 'true') return;
    root.dataset.wdFilmsReady = 'true';

    var modal = root.querySelector('[data-wd-modal]');
    if (!modal) return;
    var frameWell = modal.querySelector('[data-wd-modal-frame]');
    var lastFocus = null;

    function open(videoId) {
      lastFocus = document.activeElement;
      frameWell.innerHTML = '';
      var iframe = document.createElement('iframe');
      iframe.src =
        'https://www.youtube-nocookie.com/embed/' +
        encodeURIComponent(videoId) +
        '?autoplay=1&rel=0';
      iframe.title = 'Washington Diamond client film';
      iframe.allow =
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.setAttribute('style',
        'position:absolute;inset:0;width:100%;height:100%;border:0');
      frameWell.appendChild(iframe);

      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('[data-wd-modal-close]');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      modal.hidden = true;
      frameWell.innerHTML = '';
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    root.querySelectorAll('[data-wd-film]').forEach(function (card) {
      card.addEventListener('click', function () {
        var id = card.dataset.wdFilm;
        if (id) open(id);
      });
    });

    modal.querySelectorAll('[data-wd-modal-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });

    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var nodes = Array.prototype.slice.call(modal.querySelectorAll(FOCUSABLE));
        if (!nodes.length) return;
        var first = nodes[0];
        var last = nodes[nodes.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-wd-films]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-wd-films]');
    if (root) init(root);
  });
})();
